import { ApiAddress } from "config";

export async function getNewUsers() {
    return (await fetch(ApiAddress + "/new_users")).json();
}